import { ToolResult } from '../../types/tool.types';
import { FLOOR_TEXTURES } from '../../../core/constants/texture-options';

/**
 * Get available floor texture options.
 * Returns a list of floor textures with their key, name, and description.
 */
export async function getFloorOptions(): Promise<ToolResult> {
	const options = FLOOR_TEXTURES.map((texture) => ({
		key: texture.key,
		name: texture.name,
		description: texture.description,
		// Include thumbnail URL if we have one
		thumbnail: texture.texture ? `textures/${texture.texture}` : undefined
	}));

	return {
		success: true,
		data: {
			options,
			currentDefault: 'floor/grid-tile',
			usage: 'Use set_floor_texture with any key to change the floor surface'
		}
	};
}
